module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN316_1444734762.931d1f10.png";